import IconRightArrow from "assets/svgs/bx-right-arrow-circle.svg";
export default function Cards() {
  return (
    <div className="relative pl-5 mb-5">
      <IconRightArrow width="16" className="absolute top-1.5 -left-2" />
      <div
        className="border-b border-gray-200 relative pb-4 pl-12 card-list-inner"
        style={{ minHeight: "40px" }}
      >
        <div className="absolute left-0 top-0">
          {/* <Image src="/c-img.png" width={35} height={35} alt="cart" /> */}
        </div>
        <div>
          <div className="sm:flex flex-wrap mb-1">
            <h3 className=" font-semibold">Uncovered</h3>
            <span className="text-xxs sm:ml-auto text-red m1-2 sm:mt-0">
              {/* January 21st, 2020 */}
            </span>
          </div>
          <p className="text-sm">Uncovered has added a new source </p>
          <a href="#" className="text-red underline text-sm">
            [Link]
          </a>
        </div>
      </div>
    </div>
  );
}
